import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-org-management-tabs',
  standalone: true,
  imports: [MatTabsModule],
  templateUrl: './org-management-tabs.component.html',
  styleUrl: './org-management-tabs.component.css',
})
export class OrgManagementTabsComponent implements OnInit {
  currentTabIndex = 0;
  organizationsTab = $localize`Organization Details`;
  quotasTab = $localize`Quotas`;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.updateTabIndex();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateTabIndex();
      }
    });
  }

  updateTabIndex(): void {
    const currentPath = this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
    this.currentTabIndex = currentPath === 'quotas' ? 1 : 0;
    this.cdr.detectChanges();
  }

  onTabChange(index: number): void {
    this.currentTabIndex = index;
    if (index === 0) {
      this.router.navigate(['/org']);
    } else {
      this.router.navigate(['/org/quotas']);
    }
  }
}
